import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Loader2, Search } from "lucide-react";

const fmt = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "");

// Pick the second job to print on the same A4 sheet
export const PairPrintDialog = ({ open, onOpenChange, currentId, onPick }) => {
  const [q, setQ] = useState("");
  const [jobs, setJobs] = useState(null);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.get("/admin/bodyshop", { params: q ? { q } : {} }).then((r) => setJobs(r.data)).catch(() => setJobs([])), 250);
    return () => clearTimeout(t);
  }, [open, q]);
  const shown = (jobs || []).filter((j) => j.id !== currentId).sort((a, b) => (a.status === "closed") - (b.status === "closed"));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#12141A] border-white/10 max-w-md max-h-[85vh] flex flex-col" data-testid="pair-print-dialog">
        <DialogHeader><DialogTitle className="font-display uppercase">Seconda scheda da stampare</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground -mt-2">Le due copie veicolo escono sullo stesso foglio A4, una per metà.</p>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca targa o cliente" className="pl-9 h-12 text-base bg-[#181A22] border-white/10" data-testid="pair-print-search" />
        </div>
        <div className="flex-1 overflow-y-auto -mx-2 px-2 space-y-1.5">
          {!jobs ? <Loader2 className="w-5 h-5 animate-spin mx-auto my-6 text-[#E63946]" /> : shown.length === 0 ? <p className="text-sm text-muted-foreground py-6 text-center">Nessuna altra scheda trovata.</p> : shown.map((j) => (
            <button key={j.id} type="button" onClick={() => onPick(j)} className="w-full text-left rounded-xl border border-white/10 bg-[#181A22] hover:border-[#E63946]/60 px-3 py-3 transition-colors" data-testid={`pair-print-pick-${j.id}`}>
              <div className="font-semibold truncate">{j.plate || "Senza targa"} · {j.brand} {j.model}{j.status === "closed" && <span className="ml-2 text-[10px] uppercase text-[#4ADE80]">Fine lavoro</span>}</div>
              <div className="text-xs text-muted-foreground truncate">{j.number ? `N. ${j.number} · ` : ""}{j.customer_name || "Cliente non indicato"} · ingresso {fmt(j.date_in)}</div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
